import { Alert } from "./ui/alert";

type Props = {
  errors?: string[];
  notice?: string;
};

export default function PageNotices({ errors, notice }: Props) {
  if (!notice && !errors) return null;
  return (
    <>
      <div className="max-w-xl mx-auto py-4 space-y-2">
        {notice && <Alert>{notice}</Alert>}
        {errors && errors.length > 0 && <Alert variant="destructive">{errors.join(", ")}</Alert>}
      </div>
    </>
  );
}
